import dayjs from "dayjs";

const useTime = (diff: number) => {
  return dayjs(diff).format("mm:ss");
};

export default useTime;
